export default "__VITE_ASSET__ypzb9boV__"